import { getInitialState } from './index';
import { State, Recordings, Params, Recording } from './types';

const mutations = {
  setRecordings(state: State, recordings: Recordings) {
    state.recordings = recordings;
  },
  setSearchTerm(state: State, searchTerm: string) {
    state.searchTerm = searchTerm;
  },
  setIsLoading(state: State, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  resetRecordingsState(state: State) {
    Object.assign(state, getInitialState());
  },
  setCurrentPage(state: State, currentPage: number) {
    state.currentPage = currentPage;
  },
  setRecordingsCount(state: State, recordingsCount: number) {
    state.recordingsCount = recordingsCount;
  },
  setRecordingsParamsState(state: State, params: Params) {
    state.searchTerm = params.searchTerm;
    state.currentPage = params.currentPage;
  },
  openCreateRecordingDialog(state: State) {
    state.isCreateRecordingDialogOpened = true;
  },
  closeCreateRecordingDialog(state: State) {
    state.isCreateRecordingDialogOpened = false;
  },
  updateRecording(state: State, recording: Recording) {
    if (Array.isArray(state.recordings)) {
      state.recordings = state.recordings?.map((currentRecording: Recording) =>
        currentRecording.id === recording.id ? recording : currentRecording
      );
    }
  }
};

export default mutations;
